import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'antd';
import { isEmpty, isEqual, isNil } from 'lodash';
import T from 'i18n-react';
import SupplierSearcher from './SupplierSearcher';
import FactorySearcher from './FactorySearcher';
import classes from './Style.module.scss';
import ProductSearcher from './ProductSearcher';

const SEARCHERS = {
  supplier: SupplierSearcher,
  factory: FactorySearcher,
  product: ProductSearcher,
};

export default function Searcher({
  type,
  open,
  onOk,
  onCancel,
  selected,
  title,
  onBindingValue = null,
  multiple = true,
  otherSource = [],
}) {
  const latestSelected = useRef(null);
  const [selectedItem, setSelectedItem] = React.useState(selected);

  const SearcherComponent = SEARCHERS[type];
  if (SearcherComponent === undefined) {
    throw Error(`Searcher type ${type} is not supported`);
  }

  const handleOnCancel = () => {
    onCancel();
    setTimeout(() => {
      setSelectedItem(latestSelected.current);
    });
  };

  useEffect(() => {
    if (isNil(selected) || isEmpty(selected)) {
      setSelectedItem([]);
    }
    if (!isEqual(selected, latestSelected)) {
      latestSelected.current = selected;
      setSelectedItem(selected);
    }
  }, [selected]);

  return (
    <Modal
      className={classes.searcher}
      centered
      open={open}
      title={title}
      okText={T.translate('general.confirm')}
      onCancel={handleOnCancel}
      onOk={() => {
        onOk(selectedItem);
      }}
      cancelButtonProps={{
        hidden: true,
      }}>
      <SearcherComponent
        multiple={multiple}
        otherSource={otherSource}
        selected={selectedItem}
        onBindingValue={onBindingValue}
        onChange={(selectedItems) => {
          setSelectedItem(selectedItems);
        }}
      />
    </Modal>
  );
}

Searcher.propTypes = {
  selected: PropTypes.array.isRequired,
  otherSource: PropTypes.array,
  onOk: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  type: PropTypes.oneOf(['supplier', 'factory']).isRequired,
  open: PropTypes.bool,
  title: PropTypes.node,
  multiple: PropTypes.bool,
  onBindingValue: PropTypes.func,
};

Searcher.defaultProps = {
  open: false,
  multiple: true,
  title: '',
  otherSource: [],
  onBindingValue: null,
};
